export default {
  edit_note: 'Edit note',
  add_note: 'Add note ',
  update: 'Update item',
  feedback: {
    item_sold_out_one: 'We’re sorry, but we’re currently out of {{items}}.',
    item_sold_out_other: 'We’re sorry, but we’re currently out of {{items}}.',
    item_unavailable:
      'This item is only available from {{schedule}}. Please change the time of the order or remove the item to order.',
  },
  buttons: {
    update: 'Update',
  },
};
